export const welcomeData = {
  userName: "Ольга",
  averageScore: 76,
  tasks: [
    {
      id: 1,
      title: "Завдання на сьогодні",
      description: "Обробити 30 дзвінків за день",
      iconBg: "#ECF0FF",
      iconStroke: "#605DFF",
    },
  ],
  image: {
    src: "/img/welcome.png",
    width: 418,
    height: 336,
    alt: "welcome-image",
  },
};
